import {ReactNode, useState} from 'react';
import {Navigate, To, useLocation} from 'react-router-dom';
import {Splash} from '@/components/Splash';
import {useSession} from '@/hooks/session';
import {paths} from './path';

export const LoginRoute = ({children}: {children: ReactNode[] | ReactNode}) => {
  const {hasSession, isPending} = useSession();
  const location = useLocation();
  const [from] = useState<To>(location.state?.from || paths.home);

  if (isPending) {
    return <Splash />;
  } else if (hasSession) {
    return <Navigate to={from} />;
  }

  return children;
};

export default LoginRoute;
